export const SET_FEED_VIEW = "feed/SET_FEED_VIEW";
export const SET_FEED_ITEM_ORDER = "feed/SET_FEED_ITEM_ORDER";
export const FEED_SHUFFLE_ORDER = "feed/FEED_SHUFFLE_ORDER";
export const FEED_OPTIMISTIC_LIKE_POST = "feed/OPTIMISTIC_LIKE_POST";
export const FEED_MERGE_POST_PARTIAL = "feed/MERGE_POST_PARTIAL";
export const FEED_PREPEND_POST = "feed/PREPEND_POST";
export const FEED_MERGE_POSTS_COMMENTS = "feed/MERGE_POSTS_COMMENTS";
